var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDropdownVivid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8751 8.99953L11.9951 12.8795L8.1151 8.99953C7.7251 8.60953 7.0951 8.60953 6.7051 8.99953C6.3151 9.38953 6.3151 10.0195 6.7051 10.4095L11.2951 14.9995C11.6851 15.3895 12.3151 15.3895 12.7051 14.9995L17.2951 10.4095C17.6851 10.0195 17.6851 9.38953 17.2951 8.99953C16.9051 8.61953 16.2651 8.60953 15.8751 8.99953Z",
    fill: "#6C7680"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdownVivid);
export default __webpack_public_path__ + "static/media/ic_dropdown_vivid.df4cc8b648be553cb9a8f2440e6c3f96.svg";
export { ForwardRef as ReactComponent };